import {createGlobalStyle} from 'styled-components';
import Fonts from './fonts';

export default createGlobalStyle`
    ${Fonts}

    html {
        scroll-behavior: smooth;
    }
    
    ::-webkit-scrollbar {
        -webkit-appearance: none;
        background-color: ${props => props.theme.disabled};
    }

    ::-webkit-scrollbar:vertical {
        width: 10px;
    }

    ::-webkit-scrollbar:horizontal {
        height: 10px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        border: 1px solid ${props => props.theme.navText}66;
        background-color: ${props => props.theme.navText}66;

        &:hover {
            border: 1px solid ${props => props.theme.navText}99;
            background-color: ${props => props.theme.navText}99;
        }
    }

    ::-webkit-resizer {
        display: none;
    }

    .apexcharts-tooltip {
        background: ${props => props.theme.tableRow} !important;
        border: 1px solid ${props => props.theme.text} !important;
        color: ${props => props.theme.text} !important;
    }

    .apexcharts-tooltip .apexcharts-tooltip-title {
        background: ${props => props.theme.tableRow} !important;
        border-bottom: 1px solid ${props => props.theme.text} !important;
        color: ${props => props.theme.text} !important;
    }

    .apexcharts-tooltip .apexcharts-tooltip-text,
    .apexcharts-tooltip .apexcharts-tooltip-text-y-label,
    .apexcharts-tooltip .apexcharts-tooltip-text-y-value,
    .apexcharts-tooltip .apexcharts-tooltip-text-z-label,
    .apexcharts-tooltip .apexcharts-tooltip-text-z-value {
        color: ${props => props.theme.text} !important;
    }

    .apexcharts-xaxistooltip {
        background: ${props => props.theme.tableRow} !important;
        border: 1px solid ${props => props.theme.text} !important;
        color: ${props => props.theme.text} !important;
    }
`;
